<template>
  <Modal
    v-model="isVisible"
    title="买家历史订单详情"
    :mask-closable="false"
    class-name="buyer-order-history"
  >
    <div class="modal-body-main">
      <Spin class="page-loading" fix v-if="pageLoading">正在加载数据中...</Spin>
      <div class="details-head grid-columns-2 font-size-20 font-weight-bold">
        <div class="details-info">
          <span class="info-label">店铺：</span>
          <span class="info-content">{{ saleAccountName }}</span>
        </div>
        <div class="details-info">
          <span class="info-label">买家{{ `${pageDetails.buyerName ? '姓名' : 'ID'}` }}：</span>
          <span class="info-content">{{ pageDetails.buyerName || pageDetails.buyerAccountId }}</span>
        </div>
      </div>
      <div class="details-head grid-columns-4 mt10 font-size-15 font-weight-bold">
        <div class="details-info">
          <span class="info-label">总下单数：</span>
          <span class="info-content">{{ pageDetails.buyCount }}</span>
        </div>
        <div class="details-info">
          <span class="info-label">总付款金额：</span>
          <span class="info-content">{{ pageDetails.transactionPriceSum }} {{ pageDetails.transactionPriceCurrency }}</span>
        </div>
        <div class="details-info">
          <span class="info-label">总退款数：</span>
          <span class="info-content">{{ pageDetails.refundCount }}</span>
        </div>
        <div class="details-info">
          <span class="info-label">总退款金额：</span>
          <span class="info-content">{{ pageDetails.refundPriceSum }} {{ pageDetails.transactionPriceCurrency }}</span>
        </div>
      </div>
      <Table
        class="mt10"
        highlight-row
        border
        :height="320"
        :loading="tableLoading"
        :columns="tableColumn"
        :data="talbeData"
      />
      <div class="mt10 not-perm-title">以下是无权限店铺订单</div>
      <Table
        class="mt10"
        highlight-row
        border
        :height="280"
        :loading="tableLoading"
        :columns="notPermissioColumn"
        :data="notPermissioData"
      />
    </div>
    <div slot="footer">
      <Button @click="closeModal">关 闭</Button>
    </div>
  </Modal>
</template>
<script>
import api from '@/api/api';
import orderSys from '@/components/mixin/orderSys_mixin';
import Mixin from '@/components/mixin/common_mixin';

export default {
  name: "buyerOrderHistory",
  components: {},
  mixins: [Mixin, orderSys],
  props: {
    hiddenStore: { type: Boolean, default: false },
    modelVisible: {
      type: Boolean,
      default: false
    },
    moduleData: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  data () {
    return {
      isVisible: false,
      pageLoading: false,
      tableLoading: false,
      businessDeptJson: {},
      notPermissioData: [],
      pageDetails: {},
      talbeData: [],
      notPermissioColumn: [],
      cancelList: [],
      columnObj: {
        // 订单号
        salesRecordNumber: {
          title: '订单号',
          key: 'salesRecordNumber',
          align: 'center',
          minWidth: 200,
          render: (h, { row }) => {
            if (this.$common.isEmpty(row.salesRecordNumber)) return h('span', {}, '');
            let txt = row.salesRecordNumber;
            if (this.$common.isEmpty(row.accountCode)) {
              if (!this.$common.isEmpty(row.saleAccountId) && !this.$common.isEmpty(this.shopDataObj)) {
                if (!this.$common.isEmpty(this.shopDataObj[row.saleAccountId])) {
                  txt = `${this.shopDataObj[row.saleAccountId].accountCode || ''}-${txt}`;
                }
              }
            } else {
              txt = `${row.accountCode}-${txt}`;
            }
            return h('span', {
              'display': 'inline-block',
              'margin': '0 auto',
              'text-align': 'left',
            }, txt);
          }
        },
        // 产品
        productList: {
          title: "产品",
          key: "productList",
          minWidth: 160,
          align: 'center',
          render: (h, params) => {
            let data = params.row.productList;
            const len = data.length;
            let pos = [];
            data.forEach((n, i) => {
              let item = this.tableImg(h, params, "", n.pictureUrl, () => {
                this.showPicModal(data);
              }, "right-end", this.$common.isEmpty(n.quantity) ? 0 : n.quantity);
              if (i < 3) {
                pos.push(item);
                if (i === 2) {
                  pos.push(h("span", {
                    style: {
                      marginLeft: "5px",
                    },
                  }, `${len > 3 ? '...' : ''}`));
                }
              }
            });
            return h("div", pos);
          }
        },
        // 付款金额
        transactionPrice: {
          title: '付款金额',
          key: 'transactionPrice',
          align: 'center',
          minWidth: 160,
          render: (h, { row }) => {
            if (this.$common.isEmpty(row.transactionPrice)) return h('span', {}, '');
            return h('span', {}, `${row.transactionPrice} ${row.transactionPriceCurrency || ''}`);
          },
        },
        // 下单时间
        payTime: {
          title: '下单时间',
          key: 'payTime',
          align: 'center',
          minWidth: 160,
        },
        // 退款金额
        refundPrice: {
          title: '退款金额',
          key: 'refundPrice',
          align: 'center',
          minWidth: 160,
          render: (h, { row }) => {
            if (this.$common.isEmpty(row.refundPrice)) return h('span', {}, '');
            return h('span', {}, `${row.refundPrice} ${row.transactionPriceCurrency || ''}`);
          },
        },
        // 所属事业部
        businessDept: {
          title: '所属事业部',
          key: 'businessDeptId',
          align: 'center',
          minWidth: 160,
          render: (h, { row }) => {
            if (this.$common.isEmpty(row.businessDeptId)) return h('span', {}, '');
            if (this.$common.isEmpty(this.businessDeptJson[row.businessDeptId])) return h('span', {}, row.businessDeptId);
            return h('span', {}, this.businessDeptJson[row.businessDeptId].name);
          },
        }
      },
      permissioColKey: ['salesRecordNumber', 'productList', 'transactionPrice', 'payTime', 'refundPrice'],
      notPermissioColKey: ['salesRecordNumber', 'businessDept', 'transactionPrice', 'payTime', 'refundPrice'],
      tableColumn: [],
    };
  },
  watch: {
    modelVisible (newVal) {
      this.isVisible = newVal;
      newVal && this.iniaData();
    },
    isVisible (newVal) {
      this.$emit('update:modelVisible', newVal);
      !newVal && this.closeModal();
    }
  },
  computed: {
    // 订单信息
    orderDetails () {
      if (this.$common.isEmpty(this.moduleData) || this.$common.isEmpty(this.moduleData.row)) return {};
      return this.moduleData.row;
    },
    // 当前订单的平台
    orderPlatform () {
      if (this.$common.isEmpty(this.orderDetails)) return '';
      return this.orderDetails.platformId;
    },
    // 店铺列表
    shopDataObj () {
      if (this.$common.isEmpty(this.allShopList)) return {};
      let obj = {};
      this.allShopList.forEach(item => {
        obj[item.saleAccountId] = item;
      });
      return obj;
    },
    // 店铺名称
    saleAccountName () {
      if (this.$common.isEmpty(this.shopDataObj) || this.$common.isEmpty(this.pageDetails) || this.$common.isEmpty(this.pageDetails.saleAccountId)) return '';
      if (this.$common.isEmpty(this.shopDataObj[this.pageDetails.saleAccountId])) return '';
      return this.shopDataObj[this.pageDetails.saleAccountId].accountCode || '';
    },
    // 当前订单对应的平台店铺
    permissioShop () {
      if (this.$common.isEmpty(this.orderPlatform) || this.$common.isEmpty(this.allShopList)) return [];
      const sList = this.allShopList.filter(f => f.platformId == this.orderPlatform);
      return sList;
    },
    // 有权限的店铺ID
    permissioAccountId () {
      if (this.$common.isEmpty(this.permissioShop)) return [];
      return this.permissioShop.map(m => m.saleAccountId);
    }
  },
  created () {},
  methods: {
    // 获取数据
    iniaData () {
      this.pageLoading = true;
      let beforeRes = [
        this.getPlatformGroup,
        this.getBusinessDeptData,
      ];
      this.tableColumn = this.permissioColKey.map(key => this.columnObj[key]);
      this.notPermissioColumn = this.notPermissioColKey.map(key => this.columnObj[key]);
      this.$common.promiseAll(beforeRes).finally(() => {
        this.$common.promiseAll([
          () => {
            const allPlat = this.platformGroupList.map(m => m.platformId);
            return this.getShopList(null, null, allPlat, false, true);
          },
          () => {
            let orderId = this.orderDetails.orderId;
            if (this.$common.isEmpty(orderId) && !this.$common.isEmpty(this.orderDetails.orderShippingOrderBoList)) {
              orderId = this.orderDetails.orderShippingOrderBoList[0].orderId;
            }
            return this.getDetails(orderId);
          }
        ]).finally(() => {
          this.pageLoading = false;
        })
      });
    },
    // 获取信息
    getDetails (orderId) {
      return new Promise((resolve) => {
        this.tableLoading = true;
        this.talbeData = [];
        this.pageDetails = {};
        if (this.$common.isEmpty(orderId)) {
          this.tableLoading = false;
          return resolve({ state: 'finally' });
        }
        const apiUrl = `${api.queryBuyerHistoryOrder}/${orderId}`;
        this.cancelList.push(apiUrl);
        this.axios.post(apiUrl).then((res) => {
          this.cancelList = this.cancelList.filter(key => apiUrl != key);
          if (res && res.data && res.data.code == 0) {
            const newRes = this.$common.copy(res.data.datas || {});
            let orderIdPos = [];
            let sortRows = [];
            let afterRow = [];
            let picKey = [];
            newRes.buyerHistoryOrderDetailVOList.forEach(item => {
              if (this.$common.isEmpty(item.payTime)) {
                afterRow.push({
                  ...item,
                  productList: item.productMapList.map(m => {
                    picKey = Object.keys(m);
                    return { pictureUrl: picKey[0], quantity: m[picKey[0]] }
                  }),
                });
              } else {
                sortRows.push({
                  ...item,
                  productList: item.productMapList.map(m => {
                    picKey = Object.keys(m);
                    return { pictureUrl: picKey[0], quantity: m[picKey[0]] }
                  }),
                });
              }
              orderIdPos.push(item.orderId);
            });
            delete newRes.buyerHistoryOrderDetailVOList;
            this.pageDetails = newRes;
            // 按照下单时间，倒序排序
            sortRows.sort((a, b) => {
              return new Date(b.payTime) - new Date(a.payTime);
            });
            let permissioList = [];
            let notPermissioList = [];
            ([...sortRows, ...afterRow]).forEach(row => {
              if (this.permissioAccountId.includes(row.saleAccountId)) {
                permissioList.push(row);
              } else {
                notPermissioList.push(row);
              }
            });
            this.talbeData = permissioList;
            this.notPermissioData = notPermissioList;
            this.tableLoading = false;
            resolve({ state: 'finally' });
            // this.getProductList([...sortRows, ...afterRow], orderIdPos).then(tableRows => {
            //   this.getImg(tableRows, { replaceType: 'empty' }).then(newRows => {
            //     let permissioList = [];
            //     let notPermissioList = [];
            //     (newRows.data || []).forEach(row => {
            //       if (this.permissioAccountId.includes(row.saleAccountId)) {
            //         permissioList.push(row);
            //       } else {
            //         notPermissioList.push(row);
            //       }
            //     });
            //     this.talbeData = permissioList;
            //     this.notPermissioData = notPermissioList;
            //   }).finally(() => {
            //     this.tableLoading = false;
            //     resolve({ state: 'finally' });
            //   });
            // }).catch(() => {
            //   this.tableLoading = false;
            //   resolve({ state: 'finally' });
            // });
          } else {
            this.tableLoading = false;
            resolve({ state: 'finally' });
          }
        }).catch((err) => {
          this.cancelList = this.cancelList.filter(key => apiUrl != key);
          console.warn(err);
          this.tableLoading = false;
          resolve({ state: 'finally' });
        })
      })
    },
    // 获取产品图片
    getImg (arrList, obj) {
      return new Promise((resolve) => {
        let busineseIdList = []
        arrList.forEach(itema => {
          itema.productList.forEach(itemb => {
            if (this.$common.isEmpty(itemb.orderTransactions)) {
              itemb.orderTransactions = [];
            }
            if (itemb.businessId && !busineseIdList.includes(itemb.businessId)) busineseIdList.push(itemb.businessId);
          })
        });
        const apiUrl = api.query_imageByProductGoodsIds;
        this.cancelList.push(apiUrl);
        this.axios.post(apiUrl, busineseIdList).then(res => {
          this.cancelList = this.cancelList.filter(key => apiUrl != key);
          arrList.forEach(itema => {
            itema.productList.forEach(itemb => {
              res.data.datas.forEach(itemc => {
                if (itemc.businessId == itemb.businessId) {
                  if (!this.$common.isUndefined(itemb.packagePictureUrl)) {
                    itemb.packagePictureUrl = itemc.path;
                  }
                  if (this.$common.isEmpty(obj.replaceType) || obj.replaceType == 'all') {
                    itemb.pictureUrl = itemc.path;
                  } else if (obj.replaceType == 'empty') {
                    if ((this.$common.isEmpty(itemb.pictureUrl) || itemb.pictureUrl.includes('/static/images/placeholder.jpg'))) {
                      itemb.pictureUrl = itemc.path;
                    }
                  }
                }
              })
            })
          });
          this.$nextTick(() => {
            resolve({ data: arrList, state: 'finally' });
          });
        }).catch(() => {
          this.cancelList = this.cancelList.filter(key => apiUrl != key);
          resolve({ data: arrList, state: 'finally' });
        })
      });
    },
    // 获取事业部
    getBusinessDeptData () {
      return new Promise((resolve) => {
        this.axios.get(api.get_businessDeptList).then(res => {
          if (res && res.data) {
            (res.data.data || []).forEach(item => {
              this.$set(this.businessDeptJson, item.id, item);
            });
            return resolve(res.data.data || []);
          }
          resolve([]);
        }).catch(() => {
          resolve([]);
        })
      })
    },
    // 关闭弹窗
    closeModal () {
      this.cancelList.forEach(key => {
        this.$store.commit('cancelPending', key);
      });
      this.$nextTick(() => {
        this.cancelList = [];
        this.isVisible = false;
        setTimeout(() => {
          this.notPermissioData = [];
          this.talbeData = [];
        }, 300);
      })
    },
  }
};
</script>
<style lang="less" scoped>
@labelWidth: 100px;
.modal-body-main{
  position: relative;
  .details-head{
    display: grid;
    &.grid-columns-2{
      gap: 10px;
      grid-template-columns: calc(43% - 5px) calc(57% - 5px);
    }
    &.grid-columns-4{
      gap: 10px;
      grid-template-columns: calc(25% - 8px) calc(25% - 7px) calc(25% - 7px) calc(25% - 8px);
    }
    .details-info{
      display: flex;
      .info-label{
        line-height: 1.3em;
        width: @labelWidth;
        text-align: right;
      }
      .info-content{
        line-height: 1.3em;
        width: calc(100% - @labelWidth);
        word-wrap: break-word;
      }
    }
  }
  .font-size-15{
    font-size: 15px;
  }
  .font-size-20{
    font-size: 20px;
  }
  .font-weight-bold {
    font-weight: bold ;
  }
  .not-perm-title{
    .font-weight-bold;
    .font-size-20;
    text-align: center;
  }
}
</style>
<style lang="less">
.buyer-order-history{
  .ivu-modal{
    position: relative;
    width: 80% !important;
    max-width: 1200px;
    min-width: 900px;
    top: 30px;
  }
  .ivu-modal-body{
    padding: 0;
    max-height: initial;
    height: calc(100vh - 160px);
  }
  .modal-body-main {
    padding: 16px;
  }
  .page-loading {
    position: sticky;
    height: calc(100vh - 160px);
    top: 0;
    z-index: 999999999;
  }
}
</style>
